<template>
  <div class="container text-center leaderboard-wrapper">
    <canvas
      id="firework-canvas"
      v-show="$store.state.slide.type == 'leaderboard' &&
        data.audience && data.audience.totalPoint &&
        data.index == 1 && !showWaitingScreen"
    />
    <div v-if="!showWaitingScreen" class="f-h">
      <div v-if="!isAudienceFormShowing" class="f-h">
        <div v-if="!loading" class="f-h">
          <div v-if="waitingLeadboard" class="f-h">
            <div v-if="!noResult" class="text-center waiting-leadeboard">
              <Loading />Let's see your score and ranking...
            </div>
            <div v-if="noResult" class="padding">
              <h2 v-if="$store.state.slide.title" class="mt-0 text-left slide-title-style">
                <span
                  :inner-html.prop="leaderboardTitleHTML"
                  v-if="isTitleLeaderboardVisible"
                />
              </h2>
              <div class="no-result-yet-text">
                {{ $t("noResultYet") }}
              </div>
            </div>

            <div
              class="audio-control-slide"
              v-if="$store.state.slide.audioLink &&
                $store.state.slide.audioPlayOnAudience &&$store.state.slide.id"
            >
              <AudioControl />
            </div>
          </div>
          <div v-if="!waitingLeadboard" class="f-h fix-content-leaderboard">
            <QuizBrag
              v-if="data.lastSlide"
              :data="data"
              :total="getTotal"
              :percentile="getRanking.percentile"
            />
            <!-- Not win, has data.audience -->
            <div
              class="no-win m-b-8"
              v-if="!data.lastSlide"
            >
              <div class="title-leaderboard">
                <span
                  :inner-html.prop="leaderboardTitleHTML"
                  v-if="isTitleLeaderboardVisible"
                />
                <span class="count-player">
                  {{ $t('players', { msg: countPlayer || '...' }) }}
                </span>
              </div>

              <QuizCounter
                :is-completed="true"
                :number-of-quizzes="totalQuiz"
                :number-of-quizzes-have-passed="currentQuiz"
                v-if="currentQuiz && data.audience"
              />

              <div
                v-if="data.index && $store.state.presentation.language == 'en' && data.audience"
                class="point-audience m-b-8"
              >
                You got
                <strong>{{ data.index | countEnglish }}</strong>
                place out of <strong>{{ data.audiencesCount }}</strong> players
              </div>
            </div>

            <!-- Not win, no data.audience -->
            <div class="no-win m-b-8" v-if="!data.audience">
              <div
                v-if="data.index && $store.state.presentation.language == 'en'"
                class="point-audience"
              >
                You got
                <strong>{{ data.index | countEnglish }}</strong>
                place out of <strong>{{ data.audiencesCount }}</strong> players
              </div>
              <div
                v-if="data.index && $store.state.presentation.language != 'en'"
                class="point-audience"
                v-html="$t(
                  'youAreInPlace',
                  {
                    msg: '<strong>' + data.indexFormat + '</strong>',
                    msg1: '<strong>' + data.audiencesCount + '</strong>',
                  }
                )"
              />
              <div
                class="point-audience m-b-8"
                v-html="$t('haventAnsweredAnyQuiz')"
                v-if="!isFinalLeaderboard"
              />
              <div
                class="point-audience"
                v-html="$t('yourTotalScoreIs', {
                  msg: '<strong>0</strong>'
                })"
              />
            </div>

            <!-- Audio control -->
            <div
              class="audio-control-slide"
              v-if="
                $store.state.slide.audioLink
                  && $store.state.slide.audioPlayOnAudience
                  && $store.state.slide.id
              "
            >
              <AudioControl />
            </div>

            <CtaButton
              :variant="$store.state.slide.textColour === '#ffffff' ? 'white' : 'dark'"
              v-if="data.lastSlide && data.audiencesCount"
              v-show="isPresentationLastSlide && showAhaSlidesCTA && isNotWhiteLabel"
              @click="handleClickOnButtonCTA()"
            />

            <!-- Button Next slide -->
            <div class="cta-wrapper button-next-wrapper" v-if="!isPresentationLastSlide && audiencePacing">
              <Buttonv2
                size="lg"
                block
                @click="handleClickNextSlide()"
              >
                <span>{{ $t('nextButton') }}</span>
                <AhaSvg
                  name="arrow-no-tail"
                  view-box="0 0 8 14"
                />
              </Buttonv2>
            </div>

            <ScoreLeaderboardContent
              type="individual"
              :data="scoreLeaderBoard"
              @nextToWaitingScreen="handleWaitingScreen()"
            />
          </div>
        </div>
        <div v-if="loading" class="horizontal layout center center-justified">
          <Loading />
        </div>
      </div>

      <QuizJoinGameForm v-if="isAudienceFormShowing" @joinGame="getResult()" />
    </div>

    <div v-if="showWaitingScreen && !lastSlide">
      <SlideWaiting />
    </div>
  </div>
</template>
<script>
import * as Sentry from '@sentry/vue'

import Constant from '@/constant'
import utils from '@/util'
import EventBus from '@/eventBus'
import { mapState } from 'vuex'

import Config from '@/config'

// components
import QuizCounter from '@/components/common/QuizCounter.vue'
import CtaButton from '@/components/common/CtaButton.vue'
import QuizBrag from '@/components/quiz/QuizBrag.vue'

// containers
import QuizCounterContainer from '@/containers/common/QuizCounter'

// UI
import SlideWaiting from '@/components/SlideWaiting.vue'
import Loading from '@/components/Loading.vue'
import AudioControl from '@/components/AudioControl.vue'
import QuizJoinGameForm from '@/components/QuizJoinGameForm.vue'

// Utils
import {
  getTotalCount,
  getRankingById,
} from '@/components/utils/leaderboard'

import ScoreLeaderboardContent from '@/components/types/ScoreLeaderboardContent.vue'
import Buttonv2 from '../UI/Buttonv2.vue'

export default {
  components: {
    SlideWaiting,
    Loading,
    AudioControl,
    QuizJoinGameForm,
    ScoreLeaderboardContent,
    Buttonv2,
    QuizCounter: QuizCounterContainer(QuizCounter),
    QuizBrag,
    CtaButton,
  },
  data() {
    return {
      audienceName: this.$store.state.audienceName,
      data: {},
      leaderboardData: {},
      showWaitingScreen: false,
      myReq: null,
      loading: true,
      waitingLeadboard: true,
      noResult: false,
      lastSlide: false,
      currentQuiz: null,
      totalQuiz: null,
      countPlayer: 0,
    }
  },
  computed: {
    ...mapState({
      audienceId: (state) => state.audienceId,
      audiencePacing: (state) => state.presentation.audiencePacing,
      presentationID: (state) => state.presentation.id,
      showAhaSlidesCTA: (state) => state.presentation.showAhaSlidesCTA,
      slideActive: (state) => state.slide,
      slides: (state) => state.slides,
      isNotWhiteLabel: (state) => {
        return state.presentation.planType !== 'white-label'
      },
      isPresentationLastSlide: (state) => {
        return state.slide.id === state.presentation.lastSlide
      },
      isFinalLeaderboard: (state) => {
        let isFinalLeaderboard = false
        if (state.slides) {
          const slidesQuiz = state.slides.filter((item) => {
            return item.type === 'pickAnswer'
          })

          const index = state.slides.findIndex((item) => item.id === state.slide.id)
          let indexQuiz = 0
          if (slidesQuiz.length) {
            indexQuiz = state.slides.findIndex(
              (item) => item.id === slidesQuiz[slidesQuiz.length - 1].id,
            )
          }
          if (index > indexQuiz) {
            isFinalLeaderboard = true
          }
        }

        return isFinalLeaderboard
      },
    }),
    isAudienceFormShowing() {
      return !this.$store.state.audienceName || !this.$store.state.isAudienceEmojiDisabled
    },
    getRanking() {
      return getRankingById(this.leaderboardData, this.audienceId)
    },
    getTotal() {
      return getTotalCount(this.leaderboardData)
    },
    isTitleLeaderboardVisible() {
      const { title } = this.slideActive
      return title == null || (title && title.trim().length)
    },
    leaderboardTitleHTML() {
      return this.slideActive.titleHTML || this.slideActive.title || 'Leaderboard'
    },
  },
  destroyed() {
    if (this.myReq) {
      window.cancelAnimationFrame(this.myReq)
    }

    EventBus.$off('answer-quiz')
  },
  mounted() {
    if (this.$store.state.audienceName) {
      this.getResult()
    } else {
      this.loading = false
    }

    EventBus.$on('answer-quiz', (data) => {
      if (this.$store.state.audienceName && this.waitingLeadboard) {
        this.handleDataSuccess(data)
      }
    })
    if (this.$store.state.slide.id === this.$store.state.presentation.lastSlide) {
      this.lastSlide = true
    }

    // Firing confetti effect only available if the canvas element is mounted to the DOM
    const canvas = document.getElementById('firework-canvas')
    const colors = Constant.colorsHex.filter((item, key) => {
      return item && key < 7
    })

    this.startConfettiEffect = utils.setupConfettiEffect(canvas, { resize: true },
      {
        startVelocity: 5,
        spread: 360,
        ticks: 100,
        decay: 0.98,
        particleCount: 40,
        shapes: ['circle'],
        colors,
        zIndex: 100,
      })
  },
  methods: {
    handleWaitingScreen() {
      this.showWaitingScreen = true
    },
    _createDataShowListScore(doc) {
      let total = 0
      if (doc.audiences.length) {
        total = doc.audiences[0].t
      }

      doc.audiences.forEach((item, key) => {
        item.color = Constant.colors[key % 30]
        item.oldPercent = (item.t / total) * 100 || 1
      })

      this.scoreLeaderBoard = doc.audiences
      this.countPlayer = doc.audiences.length
    },
    async getResult() {
      this.loading = true

      try {
        let doc
        if (this.$store.state.presentation.audiencePacing) {
          const res = await this.$http.post(Config.api.createLeaderboard, {
            slideId: this.$store.state.slide.id,
            isFinalLeaderboard: this.isFinalLeaderboard,
          })
          doc = res.body
        } else {
          const url = this.$store.state.slide.cacheLeaderboardUrl
          if (!url) {
            this.loading = false
            this.noResult = true
            return
          }
          const res = await this.$http.get(url)
          doc = res.body
        }
        this.loading = false

        if (!doc.id) {
          doc.audiences = []
        }
        if (!doc.audiences.length) {
          this.noResult = true
          return
        }
        this.handleDataSuccess(doc)
        this.currentQuiz = doc.currentQuiz
        this.totalQuiz = doc.totalQuiz
        this._createDataShowListScore(doc)
      } catch (err) {
        this.noResult = true
        this.loading = false
        Sentry.captureException(err)
      }
    },

    handleDataSuccess(doc) {
      if (!doc.id || doc.loading) {
        this.waitingLeadboard = true
        return
      }

      this.leaderboardData = doc
      this.waitingLeadboard = false
      const index = doc.audiences.findIndex((item) => {
        return item.a === this.audienceId
      })

      if (index === -1) {
        this.data.totalQuiz = utils.numberWithCommas(doc.totalQuiz)
      }

      if (index !== -1) {
        const audience = doc.audiences[index]
        this.data.audience = {
          audience: this.audienceId,
          audienceEmoji: this.$store.state.audienceEmoji,
          audienceName: this.$store.state.audienceName,
          index: audience.i,
          totalPoint: audience.t,
          correctRate: audience.cR || 0,
        }
        this.data.index = audience.i
        this.data.audience.totalPoint = utils.numberWithCommas(this.data.audience.totalPoint)
        this.data.indexFormat = utils.numberWithCommas(audience.i)
        this.data.totalQuiz = utils.numberWithCommas(doc.totalQuiz)
      }
      this.data.lastSlide = doc.lastSlide
      this.data.audienceCount = doc.audiences.length
      this.data.audiencesCount = utils.numberWithCommas(doc.audiences.length)
      if (this.data.lastSlide) {
        this.$store.state.slide.finalLeaderboard = true
      }

      if (
        this.data.lastSlide &&
        this.data.audience &&
        this.data.audience.totalPoint &&
        this.data.index === 1
      ) {
        const self = this
        if (!self.startConfettiEffect) {
          return
        }

        let start = null

        // eslint-disable-next-line
        function step(timestamp) {
          if (!start) start = timestamp
          const progress = timestamp - start
          if (progress > 1200) {
            start = null
            self.startConfettiEffect({
              x: Math.random(),
              y: Math.random() - 0.3,
            })
          }
          self.myReq = window.requestAnimationFrame(step)
        }
        self.myReq = window.requestAnimationFrame(step)
      }
    },

    handleClickOnButtonCTA() {
      window.open(utils.generateButtonCTAURL(this.presentationID, this.slideActive, 'leaderboard_CTA'), '_blank')
      utils.trackGAButtonCTA(this.presentationID, this.slideActive)
    },

    handleClickNextSlide() {
      EventBus.$emit('skipSlide')
    },
  },
}
</script>
<style lang="scss">
.fix-content-leaderboard {
  .button-next-wrapper {
    margin-top: 4px;
    margin-bottom: 4px;
  }
}
.title-leaderboard {
  p {
    margin-top: 0;
  }
}
</style>
